/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React            from 'react';
import PropTypes        from 'prop-types';
import { StyledAnchor } from '../../atoms/StyledAnchor';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const Anchor = ({ exact, to, target, children, onAnchorClick }) => (
    <StyledAnchor onClick={onAnchorClick} exact={exact} to={to} target={target} rel={target === '_blank' ? 'noopener' : null}>{children}</StyledAnchor>
);

Anchor.propTypes = {
    onAnchorClick: PropTypes.func,
    children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/molecules/Anchor/index.js